import { Styles, css } from '@flipster/styled-system/css';

import { Picture, PictureProps } from '../../utils/Picture';

export const SparkRewardBanner = ({ css: cssProp, bannerPicture }: { css?: Styles; bannerPicture: PictureProps }) => {
  return (
    <div className={css(cssProp)}>
      <Picture
        className={css({
          '& > img': {
            display: 'block',
            width: '100%',
            height: 'auto',
          },
        })}
        {...bannerPicture}
      />
    </div>
  );
};
